// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1PIQu","buttons":"SendReceipts_buttons__1wCiq","email":"SendReceipts_email__3lpZQ","bookApptTitle":"SendReceipts_bookApptTitle__2OBCw"};